import axios from "axios";
import type { PaginatedResponse } from "../dto/commons";
import type { PurchaseRow } from "../dto/purchases.dto";
import { BACKEND_URL } from "../utils/constants";

export interface GetPurchaseReportQuery {
  companyId: number;
  startDate: string;
  endDate: string;
  limit?: number;
  page?: number;
  branchIds?: number[];
  vendorIds?: number[];
  productIds?: number[];
  type?: "in_invoice" | "in_refund";
}

export const getPurchaseReport = async ({
  page = 10,
  limit = 1,
  ...params
}: GetPurchaseReportQuery) => {
  return axios
    .get<PaginatedResponse<PurchaseRow>>(`${BACKEND_URL}/reports/purchases`, {
      params: {
        page,
        limit,
        ...params,
      },
      paramsSerializer: {
        indexes: null,
      },
    })
    .then((res) => res.data);
};

export const exportPurchaseReport = async (
  params: Omit<GetPurchaseReportQuery, "limit" | "page">,
): Promise<void> => {
  const response = await axios.post(
    `${BACKEND_URL}/reports/purchases/export`,
    { ...params },
    {
      responseType: "blob",
    },
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;

  const contentDisposition = response.headers["content-disposition"];
  let fileName = `purchases_report_${params.startDate}_to_${params.endDate}.xlsx`;
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
    if (fileNameMatch && fileNameMatch.length === 2)
      fileName = fileNameMatch[1];
  }

  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
